import * as baseTheme from './base';

const component = {
  titleBgColor: baseTheme.colors.bl900,

  // HowTo
  howToBgColor: baseTheme.colors.bl900,
  howToTitleColor: baseTheme.colors.black,

  // Footer
  footerBgColor: baseTheme.colors.white,
};

const blue = {
  ...baseTheme,
  component,
};

export { blue };
